import React, { useEffect, useState } from "react";
import UserTable from "../../components/Admin/Users/UserTable";
import {
  getAllUsers,
  deleteUser,
  updateUser,
} from "../../services/userService";
import { toast } from "react-hot-toast";

const UserManagement = () => {
  const [users, setUsers] = useState([]);

  const fetchUsers = async () => {
    try {
      const data = await getAllUsers();
      setUsers(data);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleToggleActive = async (userId) => {
    try {
      const userToToggle = users.find((u) => u._id === userId);
      if (!userToToggle) return;

      const updated = {
        ...userToToggle,
        isActive: !userToToggle.isActive,
      };

      await updateUser(userId, updated);
      fetchUsers();
    } catch (err) {
      console.error("Toggle active failed:", err);
    }
  };

  const handleDelete = async (userId) => {
    {
      try {
        await deleteUser(userId);
        toast.success("User Deleted Successfully");
        fetchUsers();
      } catch (err) {
        toast.error(err.response.data.message || "Failed to delete user");
        console.error("Delete failed:", err);
      }
    }
  };

  const handleUserAdded = () => {
    fetchUsers();
  };

  return (
    <div>
      <UserTable
        users={users}
        onToggleActive={handleToggleActive}
        onDelete={handleDelete}
        onUserAdded={handleUserAdded}
      />
    </div>
  );
};

export default UserManagement;
